<template>
  <div>
    <div v-if="team" class="flex items-center border-l-4 border-red-darker px-4 py-6 my-4 rounded shadow-error lg:max-w-md">
      <div class="mr-4"> 
        <i class="sp-icon-file-code-warning-1 text-white relative bg-red-darker rounded-full text-center text-2xl font-300 leading-loose p-2" style="top:4px"></i>
        </div>
      <div class="w-full">
        <div>
          <p class="font-bold text-red-darker text-lg mb-1">{{ $t('team.delete_team') }}</p>
        
          <p class="text-grey text-sm font-medium">{{ $t('team.delete') }}</p>
        </div>
        <div class="mt-6 text-right">
          <sp-button theme="red" space="xxsmall" size="small" class="mb-2 sm:mb-0" type="button" @click="deleteTeam"><i class="far fa-trash-alt mr-2"></i> {{ $t('team.remove') }}</sp-button>
          <sp-button theme="grey" space="xxsmall" size="small" class="mb-2 sm:mb-0" type="button" @click="annulerTeam"><i class="fas fa-ban mr-2"></i> {{ $t('team.cancel') }}</sp-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_TEAM, DELETE_TEAM } from "@/store/actions.type";
import { mapGetters } from "vuex";
import ButtonVue from "../../components/spKit/Button.vue";

export default {
  name: "teamDelete",
  components: {
    "sp-button": ButtonVue
  },
  data() {
    return {
      errors: [],
      team: null
    };
  },
  mounted() {
    let isEcosystem = this.currentUser.role != 'sso' ? false : true;
    this.$store
      .dispatch(GET_TEAM, {
        app_id: this.$route.params.app_id,
        team_id: this.$route.params.team_id,
        ecosystem: isEcosystem
      })
      .then(({ data }) => {
        this.team = data.team_member;
      });
  },
  methods: {
    annulerTeam(){
     this.$router.push({ name: 'teams'});
    },
    deleteTeam() {
      this.$Progress.start();
      this.errors = [];
      let isEcosystem = this.currentUser.role != 'sso' ? false : true;
      this.$store
        .dispatch(DELETE_TEAM, {
          app_id: this.$route.params.app_id,
          user_id: this.team.user_id,
          ecosystem: isEcosystem
        })
        .then(() => {
          this.$Progress.finish();
          this.inProgress = false;
          this.$router.push({
            name: isEcosystem ? "EcoTeam" : "teams",
            params: { app_id: this.$route.params.app_id }
          });
        })
        .catch(({ response }) => {
          this.inProgress = false;
          if (response) this.errors = response.data.meta.errors;
        });
    }
  },
  watch:{
    errors(){
       this.$Progress.fail()
    }
  },
  computed: {
    ...mapGetters(["session", "currentUser"])
  }
};
</script>
